// Client-side resize + compress so base64 payloads stay small.
// Photos are saved as WebP (smaller, faster pages). Browsers that cannot
// encode WebP (e.g. older Safari) fall back to JPEG automatically.

// File-picker filter: any image, with WebP listed explicitly so every OS shows .webp files.
export const IMAGE_ACCEPT = "image/*,.webp,.jpg,.jpeg,.png";

const IMAGE_EXT = /\.(webp|jpe?g|png|gif|bmp|avif)$/i;

// Some systems report an empty MIME type for .webp files, so also check the extension.
export function isImageFile(file) {
  if (!file) return false;
  if (file.type && file.type.startsWith("image/")) return true;
  return IMAGE_EXT.test(file.name || "");
}

function readAsDataUrl(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = src;
  });
}

export default async function resizeImage(file, maxWidth = 1600, quality = 0.85) {
  let dataUrl = await readAsDataUrl(file);
  // Files with a blank MIME type come back as application/octet-stream; relabel so the browser decodes them.
  if (/^data:(application\/octet-stream)?;base64,/.test(dataUrl) && /\.webp$/i.test(file.name || "")) {
    dataUrl = dataUrl.replace(/^data:[^;]*;/, "data:image/webp;");
  }
  const img = await loadImage(dataUrl);
  const scale = Math.min(1, maxWidth / img.width);
  const w = Math.round(img.width * scale);
  const h = Math.round(img.height * scale);
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  canvas.getContext("2d").drawImage(img, 0, 0, w, h);
  const webp = canvas.toDataURL("image/webp", quality);
  if (webp.startsWith("data:image/webp")) return webp;
  return canvas.toDataURL("image/jpeg", quality);
}
